(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  var LP = {
    A: { handle: 'privacyfilter-laptop-13-3-inch-16-10', title: 'Brosendaal Privacy Filter Laptop 13,3 inch 16:10 (287 × 180 mm) – Anti-spy Schermfilter', size: '13.3 inch', ratio: '16:10', width: '287', height: '180' },
    B: { handle: 'privacyfilter-laptop-13-inch-16-9', title: 'Brosendaal Privacy Filter Laptop 13,3 inch 16:9 (294 × 166 mm) – Anti-spy Schermfilter', size: '13.3 inch', ratio: '16:9', width: '294', height: '166' },
    C: { handle: 'privacyfilter-laptop-14-inch-16-10', title: 'Brosendaal Privacy Filter Laptop 14 inch 16:10 (304 × 190 mm) – Anti-spy Schermfilter', size: '14 inch', ratio: '16:10', width: '304', height: '190' },
    D: { handle: 'privacyfilter-laptop-14-inch-16-9', title: 'Brosendaal Privacy Filter Laptop 14 inch 16:9 (310 × 174 mm) – Anti-spy Schermfilter', size: '14 inch', ratio: '16:9', width: '310', height: '174' },
    E: { handle: 'privacyfilter-laptop-15-4-inch-15-6', title: 'Brosendaal Privacy Filter Laptop 15,4/15,6 inch 16:10 (332 × 208 mm) – Anti-spy Schermfilter', size: '15.4/15.6 inch', ratio: '16:10', width: '332', height: '208' },
    F: { handle: 'privacyfilter-laptop-15-6-inch-16-9', title: 'Brosendaal Privacy Filter Laptop 15,6 inch 16:9 (345 × 194 mm) – Anti-spy Schermfilter', size: '15.6 inch', ratio: '16:9', width: '345', height: '194' },
    G: { handle: 'privacyfilter-laptop-16-inch-16-10', title: 'Brosendaal Privacy Filter Laptop 16 inch 16:10 (344 × 215 mm) – Anti-spy Schermfilter', size: '16 inch', ratio: '16:10', width: '344', height: '215' }
  };
  var MP = {
    a: { handle: 'privacy-filter-monitor-21-5-inch-16-9-476-268-mm', title: 'Brosendaal Privacy Filter Monitor 21,5 inch 16:9 (476 × 268 mm) – Anti-spy Schermfilter', size: '21.5 inch', ratio: '16:9', width: '476', height: '268' },
    b: { handle: 'privacy-filter-monitor-22-inch-16-10-474-297-mm', title: 'Brosendaal Privacy Filter Monitor 22 inch 16:10 (474 × 297 mm) – Anti-spy Schermfilter', size: '22 inch', ratio: '16:10', width: '474', height: '297' },
    c: { handle: 'privacy-filter-monitor-23-8-inch-16-9-528-297-mm', title: 'Brosendaal Privacy Filter Monitor 23,8 inch 16:9 (528 × 297 mm) – Anti-spy Schermfilter', size: '23.8 inch', ratio: '16:9', width: '528', height: '297' },
    d: { handle: 'privacyfilter-monitor-24-16-10', title: 'Brosendaal Privacy Filter Monitor 24 inch 16:10 (517 × 323 mm) – Anti-spy Schermfilter', size: '24 inch', ratio: '16:10', width: '517', height: '323' },
    e: { handle: 'privacyfilter-monitor-24-16-09', title: 'Brosendaal Privacy Filter Monitor 24 inch 16:9 (531 × 298 mm) – Anti-spy Schermfilter', size: '24 inch', ratio: '16:9', width: '531', height: '298' },
    f: { handle: 'privacyfilter-monitor-27-16-10', title: 'Brosendaal Privacy Filter Monitor 27 inch 16:10 (582 × 364 mm) – Anti-spy Schermfilter', size: '27 inch', ratio: '16:10', width: '582', height: '364' },
    g: { handle: 'privacyfilter-monitor-27-16-9', title: 'Brosendaal Privacy Filter Monitor 27 inch 16:9 (598 × 337 mm) – Anti-spy Schermfilter', size: '27 inch', ratio: '16:9', width: '598', height: '337' }
  };
  function list(map) { return Object.keys(map).map(function (k) { return map[k]; }); }
  var laptopProducts = list(LP);
  var monitorProducts = list(MP);

  var OTHER = '__other__';
  var NONE = '__none__';
  LP.X = { handle: NONE };
  MP.x = { handle: NONE };

  function contactLinks() {
    var s = 'color:#961e20;font-weight:700;text-decoration:underline';
    return '<a style="' + s + '" href="/pages/contact">contactformulier</a>, <a style="' + s + '" href="https://wa.me/31633166514">WhatsApp</a> of <a style="' + s + '" href="mailto:info@brosendaal.nl">info@brosendaal.nl</a>';
  }

  var laptopRaw = [
    ['Dell XPS 13 (9300/9310/9315/9320)', 'A'], ['Dell XPS 13 Plus (9320/9340)', 'A'], ['Dell XPS 13 (9370/9380)', 'B'],
    ['Dell XPS 15 (9500/9510/9520/9530)', 'E'], ['Dell XPS 15 (9550/9560/9570)', 'F'], ['Dell XPS 16 (9640)', 'G'],
    ['Dell Latitude 7320/7330', 'B'], ['Dell Latitude 7340', 'A'], ['Dell Latitude 7400/7410/7420/7430', 'D'], ['Dell Latitude 7440', 'C'],
    ['Dell Latitude 3420/3430/3440', 'D'], ['Dell Latitude 5400/5410/5420/5430/5440', 'D'],
    ['Dell Latitude 3500/3510/3520/3530/3540', 'F'], ['Dell Latitude 5500/5510/5520/5530/5540', 'F'],
    ['Dell Inspiron 14 (oudere modellen)', 'D'], ['Dell Inspiron 15 (3000/5000/7000-serie)', 'F'],
    ['Dell Vostro 3400/3420/3430', 'D'], ['Dell Vostro 3500/3510/3520/3530', 'F'], ['Dell Precision 3560/3570', 'F'],

    ['Lenovo ThinkPad X1 Nano', 'A'], ['Lenovo ThinkPad X13 (Gen 1-2)', 'B'], ['Lenovo ThinkPad X13 (Gen 3 en nieuwer)', 'A'], ['Lenovo ThinkPad X390/X395', 'B'],
    ['Lenovo ThinkPad T14 (Gen 1-2)', 'D'], ['Lenovo ThinkPad T14 (Gen 3 en nieuwer)', 'C'],
    ['Lenovo ThinkPad T14s (Gen 1-2)', 'D'], ['Lenovo ThinkPad T14s (Gen 3 en nieuwer)', 'C'], ['Lenovo ThinkPad T480/T490', 'D'],
    ['Lenovo ThinkPad T15/T590', 'F'], ['Lenovo ThinkPad T16', 'G'], ['Lenovo ThinkPad P15s', 'F'],
    ['Lenovo ThinkPad X1 Carbon (Gen 1-8)', 'D'], ['Lenovo ThinkPad X1 Carbon (Gen 9 en nieuwer)', 'C'], ['Lenovo ThinkPad X1 Yoga (Gen 6 en nieuwer)', 'C'],
    ['Lenovo ThinkPad L14', 'D'], ['Lenovo ThinkPad L15', 'F'], ['Lenovo ThinkPad E14 (Gen 1-4)', 'D'], ['Lenovo ThinkPad E14 (Gen 5 en nieuwer)', 'C'], ['Lenovo ThinkPad E15 (Gen 1-4)', 'F'],
    ['Lenovo ThinkBook 15', 'F'], ['Lenovo IdeaPad 3/5 (15.6 inch)', 'F'], ['Lenovo IdeaPad 1 (15.6 inch)', 'F'], ['Lenovo IdeaPad 3 (14 inch)', 'D'],
    ['Lenovo V15', 'F'], ['Lenovo V14', 'D'], ['Lenovo Legion 5 (15.6 inch)', 'F'], ['Lenovo Legion 5 Pro (16 inch)', 'G'], ['Lenovo Legion Pro 7 (16 inch)', 'G'],
    ['Lenovo Yoga 7i / Yoga Slim 7 (14 inch, nieuwere generaties)', 'C'],

    ['HP EliteBook 830 G5/G6/G7/G8', 'B'], ['HP EliteBook 830 G9/G10', 'A'], ['HP EliteBook 840 G5/G6/G7/G8', 'D'], ['HP EliteBook 840 G9/G10', 'C'],
    ['HP EliteBook 850 G5/G6/G7/G8', 'F'], ['HP ProBook 430 G7/G8', 'B'], ['HP ProBook 440 G6/G7/G8/G9', 'D'], ['HP ProBook 450 G6/G7/G8/G9', 'F'],
    ['HP 250/255 (G8/G9/G10)', 'F'], ['HP 15s', 'F'], ['HP 14s', 'D'], ['HP Pavilion 15', 'F'], ['HP Pavilion x360 14', 'D'],
    ['HP Envy 13 (oudere generaties)', 'B'], ['HP Envy 15', 'F'], ['HP Spectre x360 14', 'C'], ['HP Omen 16 (nieuwere 16:10 modellen)', 'G'],

    ['Asus ZenBook 13 (UX325/UX331)', 'B'], ['Asus ZenBook 14 (UX425/UX433)', 'D'], ['Asus ZenBook 14 OLED (UX3402 en nieuwer)', 'C'],
    ['Asus ZenBook Pro 15 (UX535 en nieuwer)', 'E'], ['Asus VivoBook 14', 'D'], ['Asus VivoBook 15', 'F'], ['Asus VivoBook Pro 15 OLED', 'F'],
    ['Asus ExpertBook B1 (14 inch)', 'D'], ['Asus ExpertBook B1 (15.6 inch)', 'F'], ['Asus TUF Gaming A15/F15', 'F'], ['Asus ROG Strix G15', 'F'],
    ['Asus ROG Strix 16 / Zephyrus 16', 'G'], ['Asus ROG Zephyrus G14 (2022 en nieuwer)', 'C'],

    ['Acer Aspire 3 (15.6 inch)', 'F'], ['Acer Aspire 5 (15.6 inch)', 'F'], ['Acer Swift 3 14 (oudere modellen)', 'D'], ['Acer TravelMate P2 14', 'D'],
    ['Acer TravelMate P2 15', 'F'], ['Acer Nitro 5', 'F'], ['Acer Predator Helios 300', 'F'], ['Acer Chromebook 314 (14 inch)', 'D'], ['Acer Chromebook 315 (15.6 inch)', 'F'],

    ['Samsung Galaxy Book3 15.6', 'F'], ['Samsung Galaxy Book2 / Book2 Pro 15.6', 'F'], ['Samsung Galaxy Book3 Pro 14', 'C'], ['Samsung Galaxy Book3 Pro 16 / Ultra', 'G'],

    ['Medion Akoya E14 (14 inch)', 'D'], ['Medion Akoya E15 (15.6 inch)', 'F'],
    ['MSI Modern 14', 'D'], ['MSI Modern 15', 'F'], ['MSI Katana / Thin GF63 (15.6 inch)', 'F'],
    ['Huawei MateBook D 14', 'D'], ['Huawei MateBook D 15', 'F'], ['Huawei MateBook D 16', 'G'],

    ['Dell XPS 17 / Precision 7770 (17 inch)', 'X'], ['Lenovo ThinkPad P17 / Legion 5 (17 inch)', 'X'], ['HP ZBook Fury 17 / Omen 17 (17 inch)', 'X'],
    ['Asus ROG Strix G17 / Scar 17 (17 inch)', 'X'], ['Acer Aspire 5 17 / Predator Helios 17 / Nitro 17 (17 inch)', 'X'], ['MSI Katana 17 / Raider 17 (17 inch)', 'X']
  ];
  var laptopModelData = laptopRaw.map(function (r) { return { model: r[0], handle: LP[r[1]].handle }; });
  var laptopBrands = ['Lenovo', 'Dell', 'HP', 'Asus', 'Acer', 'Samsung', 'Medion', 'MSI', 'Huawei'];

  var monitorRaw = [
    ['dell', 'Dell E2020H / E2220H / E2222H', 'a'], ['dell', 'Dell P2219H / P2222H', 'a'], ['dell', 'Dell SE2222H', 'a'],
    ['dell', 'Dell P2419H / P2422H', 'c'], ['dell', 'Dell S2421H / S2421HS', 'c'], ['dell', 'Dell U2422H / U2424H', 'c'], ['dell', 'Dell UltraSharp U2419H', 'c'],
    ['dell', 'Dell UltraSharp U2410 / U2412M / U2415', 'd'],
    ['dell', 'Dell P2722H / P2723D', 'g'], ['dell', 'Dell S2721HS / S2722DC', 'g'], ['dell', 'Dell SE2722H', 'g'], ['dell', 'Dell U2720Q / U2723QE / U2723DE / U2722DE', 'g'],
    ['hp', 'HP P22h G4/G5 / E22 G4/G5', 'a'], ['hp', 'HP E24 / E243 / V24 / M24f', 'c'], ['hp', 'HP P24h / P24v G4/G5', 'e'], ['hp', 'HP M24fw / 24mh', 'e'],
    ['hp', 'HP E24i G4 / Z24n G2', 'd'], ['hp', 'HP P27h G4/G5 / E27 G4/G5 / M27f', 'g'], ['hp', 'HP EliteDisplay E273', 'g'],
    ['lg', 'LG 22MK430H / 22MP410', 'a'], ['lg', 'LG 24MK430H / 24MP60G', 'c'], ['lg', 'LG 24MP400', 'e'], ['lg', 'LG UltraFine 23,8 inch', 'c'],
    ['lg', 'LG 27MP400 / 27MK600M', 'g'], ['lg', 'LG 27UL500 / 27UK850 / 27UP850', 'g'], ['lg', 'LG 27GL650 / 27GN800 / 27GP850', 'g'],
    ['samsung', 'Samsung S22 Series 21,5 inch', 'a'], ['samsung', 'Samsung S24R350 / S24C310 / S24A336', 'c'], ['samsung', 'Samsung ViewFinity S6 24 inch', 'e'],
    ['samsung', 'Samsung S27R350 / S27C360', 'g'], ['samsung', 'Samsung Odyssey G5/G7 27 inch', 'g'],
    ['aoc', 'AOC 22B1HS / 22B2H / 22E1Q', 'a'], ['aoc', 'AOC 24B1H', 'e'], ['aoc', 'AOC 24B2XH', 'e'], ['aoc', 'AOC 24G2 / 24G2U / 24P2Q / 24E1Q / 24B2XDAM', 'c'],
    ['aoc', 'AOC 27B1H', 'g'], ['aoc', 'AOC 27B2H / 27G2 / Q27G2 / 27P2Q / U27B3', 'g'],
    ['asus', 'Asus VA24EHE', 'e'], ['asus', 'Asus VA24DQ / VP249QGR / VG249Q / BE24EQK / PA247CV', 'c'], ['asus', 'Asus ProArt PA248', 'd'],
    ['asus', 'Asus TUF Gaming VG27', 'g'], ['asus', 'Asus VG279Q / VG27AQ / ProArt PA278', 'g'],
    ['eizo', 'Eizo FlexScan EV2455 / EV2456 / EV2457 / EV2495', 'd'], ['eizo', 'Eizo FlexScan EV2760', 'g'], ['eizo', 'Eizo FlexScan EV2795 (27 inch 16:10)', 'f'],
    ['philips', 'Philips 221V8', 'a'], ['philips', 'Philips 241V8 / 243V7 / 242B1 / 245E1', 'c'], ['philips', 'Philips 272B7 / 273V7 / 275V8', 'g'],
    ['benq', 'BenQ GW2283', 'a'], ['benq', 'BenQ GW2480 / BL2480', 'c'], ['benq', 'BenQ GW2780 / BL2780 / PD2700U / PD2705Q', 'g'],
    ['acer', 'Acer EK220Q', 'a'], ['acer', 'Acer V247Y / KA242Y / SA240Y / Nitro VG240Y', 'c'], ['acer', 'Acer V277 / KA272 / Nitro VG270', 'g'],
    ['lenovo', 'Lenovo ThinkVision T22i', 'a'], ['lenovo', 'Lenovo ThinkVision T24i / L24i', 'c'], ['lenovo', 'Lenovo ThinkVision T27i / L27i', 'g'],
    ['iiyama', 'iiyama ProLite XUB2292HSU / E2282HS', 'a'], ['iiyama', 'iiyama ProLite XUB2492HSU / XU2493HS', 'c'], ['iiyama', 'iiyama ProLite XUB2792HSU', 'g'],
    ['msi', 'MSI PRO MP242 / MP243', 'c'], ['msi', 'MSI PRO MP271 / Optix G27', 'g'],

    ['dell', 'Dell UltraSharp U2520D (25 inch)', 'x'], ['dell', 'Dell U3223QE / S3221QS (32 inch)', 'x'], ['dell', 'Dell U3423WE / S3422DW (34 inch ultrawide)', 'x'],
    ['hp', 'HP E32 / M32f (32 inch)', 'x'], ['hp', 'HP E34m / P34hc (34 inch ultrawide)', 'x'],
    ['lg', 'LG 32UN500 / 32GN600 (32 inch)', 'x'], ['lg', 'LG 34WN80C / 34WP65C (34 inch ultrawide)', 'x'], ['lg', 'LG 25UM58 (25 inch ultrawide)', 'x'],
    ['samsung', 'Samsung S32 / Odyssey G7 32 (32 inch)', 'x'], ['samsung', 'Samsung Odyssey G9 / ViewFinity S65 (34 inch ultrawide)', 'x'],
    ['aoc', 'AOC Q32 / U32 (32 inch)', 'x'], ['aoc', 'AOC CU34 / Q34 (34 inch ultrawide)', 'x'],
    ['philips', 'Philips 328E1CA / 329P1H (32 inch)', 'x'], ['philips', 'Philips 346B1C (34 inch ultrawide)', 'x'],
    ['asus', 'Asus ProArt PA32 (32 inch)', 'x'], ['benq', 'BenQ PD3220U / EW3270U (32 inch)', 'x'], ['acer', 'Acer Predator X34 / Nitro XV340 (34 inch ultrawide)', 'x']
  ];
  var monitorModelData = monitorRaw.map(function (r) { return { brand: r[0], model: r[1], handle: MP[r[2]].handle }; });
  var monitorBrands = [['dell', 'Dell'], ['hp', 'HP'], ['lg', 'LG'], ['samsung', 'Samsung'], ['aoc', 'AOC'], ['philips', 'Philips'], ['asus', 'Asus'], ['acer', 'Acer'], ['lenovo', 'Lenovo'], ['benq', 'BenQ'], ['iiyama', 'iiyama'], ['eizo', 'Eizo'], ['msi', 'MSI']];

  function brandOf(model) {
    for (var i = 0; i < laptopBrands.length; i++) {
      if (model.indexOf(laptopBrands[i]) === 0) return laptopBrands[i];
    }
    return null;
  }

  function byHandle(set, handle) {
    for (var i = 0; i < set.length; i++) if (set[i].handle === handle) return set[i];
    return null;
  }

  function showMatch(kind, handle) {
    var product = byHandle(kind === 'laptop' ? laptopProducts : monitorProducts, handle);
    var panel = document.getElementById('ps-panel-' + kind);
    var article = panel && panel.querySelector('[data-' + kind + '-match]');
    if (!article || !product) return;
    var titleEl = article.querySelector('[data-' + kind + '-match-title]');
    var metaEl = article.querySelector('[data-' + kind + '-match-meta]');
    var linkEl = article.querySelector('[data-' + kind + '-match-link]');
    if (titleEl) titleEl.textContent = product.title;
    if (metaEl) metaEl.textContent = product.size + ' · ' + product.ratio + ' · ' + product.width + ' × ' + product.height + ' mm';
    if (linkEl) linkEl.setAttribute('href', '/products/' + product.handle);
    article.hidden = false;
    var feedback = panel.querySelector('[data-' + kind + '-feedback]');
    if (feedback) feedback.hidden = true;
  }

  function showOtherHint(kind) {
    var panel = document.getElementById('ps-panel-' + kind);
    if (!panel) return;
    var article = panel.querySelector('[data-' + kind + '-match]');
    if (article) article.hidden = true;
    var feedback = panel.querySelector('[data-' + kind + '-feedback]');
    if (feedback) {
      feedback.innerHTML = 'Geen probleem: kies hieronder de inchmaat en beeldverhouding van je ' + (kind === 'laptop' ? 'laptop' : 'monitor') + ' (staat in de specificaties of op de sticker). Of meet je scherm in 2 minuten. Is je scherm 17, 25 of 32 inch (of ultrawide)? Dan bieden we geen standaardfilter aan; neem contact op via ' + contactLinks() + '.';
      feedback.hidden = false;
    }
    var secondary = panel.querySelector('.ps-laptop-secondary');
    if (secondary) {
      secondary.scrollIntoView({ behavior: 'smooth', block: 'center' });
      secondary.style.transition = 'box-shadow .3s';
      secondary.style.boxShadow = '0 0 0 3px #961e20';
      setTimeout(function () { secondary.style.boxShadow = 'none'; }, 1800);
    }
  }

  function showNoOffer(kind, label) {
    var panel = document.getElementById('ps-panel-' + kind);
    if (!panel) return;
    var article = panel.querySelector('[data-' + kind + '-match]');
    if (article) article.hidden = true;
    var feedback = panel.querySelector('[data-' + kind + '-feedback]');
    if (feedback) {
      feedback.innerHTML = '<strong>Hiervoor hebben we helaas geen standaardfilter.</strong> ' + label + ' valt buiten onze maten. Neem contact op voor een oplossing via ' + contactLinks() + '.';
      feedback.hidden = false;
      feedback.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function addNoOfferNote(secondary) {
    var p = document.createElement('p');
    p.style.cssText = 'margin-top:12px;font-size:13px;color:#5e5953';
    p.innerHTML = 'Scherm van 17, 25 of 32 inch, of ultrawide? Dat bieden we niet standaard aan. Neem contact op via ' + contactLinks() + ' voor een oplossing.';
    secondary.appendChild(p);
  }

  function fillModelSelect(select, models) {
    select.innerHTML = '<option value="">Kies je model</option>';
    models.slice().sort(function (a, b) { return a.model.localeCompare(b.model, 'nl'); }).forEach(function (entry) {
      var opt = document.createElement('option');
      opt.value = entry.handle;
      opt.textContent = entry.model;
      select.appendChild(opt);
    });
    var other = document.createElement('option');
    other.value = OTHER;
    other.textContent = 'Mijn model staat er niet bij';
    select.appendChild(other);
    select.disabled = false;
  }

  function onModelChange(select, kind) {
    if (!select.value) return;
    if (select.value === OTHER) showOtherHint(kind);
    else if (select.value === NONE) showNoOffer(kind, select.selectedOptions[0].textContent);
    else showMatch(kind, select.value);
  }

  function buildLaptopBrandControls(container) {
    container.insertAdjacentHTML('beforeend',
      '<div class="ps-choice-row" role="group" aria-label="Kies laptopmerk" data-laptop-brand-row></div>' +
      '<label class="ps-field">' +
      '<span>Welk model heb je?</span>' +
      '<select data-laptop-model-select-v2 disabled><option value="">Kies eerst je merk</option></select>' +
      '</label>' +
      '<div class="ps-phone-tip">' +
      '<strong>Zo vind je het juiste model</strong>' +
      '<p>Kijk op de sticker onderop je laptop of zoek in Windows naar “Systeeminformatie”. Staat je model er niet bij? Kies dan “Mijn model staat er niet bij”.</p>' +
      '</div>');

    var brandRow = container.querySelector('[data-laptop-brand-row]');
    var select = container.querySelector('[data-laptop-model-select-v2]');

    laptopBrands.forEach(function (brand) {
      var models = laptopModelData.filter(function (entry) { return brandOf(entry.model) === brand; });
      if (!models.length) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ps-choice';
      btn.setAttribute('data-laptop-brand', brand.toLowerCase());
      btn.textContent = brand;
      btn.addEventListener('click', function () {
        brandRow.querySelectorAll('.ps-choice').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        fillModelSelect(select, models);
      });
      brandRow.appendChild(btn);
    });

    select.addEventListener('change', function () { onModelChange(select, 'laptop'); });
  }

  function rebuildMonitorBrandControls(controls) {
    var oldRow = controls.querySelector('.ps-choice-row');
    var oldSelect = controls.querySelector('[data-monitor-model-select]');
    if (!oldRow || !oldSelect) return;
    var row = oldRow.cloneNode(false);
    oldRow.parentNode.replaceChild(row, oldRow);
    var select = oldSelect.cloneNode(false);
    select.innerHTML = '<option value="">Kies eerst je merk</option>';
    select.disabled = true;
    oldSelect.parentNode.replaceChild(select, oldSelect);

    var tipTitle = controls.querySelector('[data-monitor-model-tip-title]');
    var tipCopy = controls.querySelector('[data-monitor-model-tip-copy]');

    monitorBrands.forEach(function (b) {
      var models = monitorModelData.filter(function (entry) { return entry.brand === b[0]; });
      if (!models.length) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ps-choice';
      btn.setAttribute('data-monitor-brand-v2', b[0]);
      btn.textContent = b[1];
      btn.addEventListener('click', function () {
        row.querySelectorAll('.ps-choice').forEach(function (x) { x.classList.remove('is-active'); });
        btn.classList.add('is-active');
        fillModelSelect(select, models);
        if (tipTitle) tipTitle.textContent = 'Zo vind je jouw ' + b[1] + '-model';
        if (tipCopy) tipCopy.textContent = 'Kijk op de sticker achterop je ' + b[1] + '-monitor of in het schermmenu onder Informatie. Staat je model er niet bij? Kies dan “Mijn model staat er niet bij”.';
        var panel = document.getElementById('ps-panel-monitor');
        var m = panel && panel.querySelector('[data-monitor-match]');
        if (m) m.hidden = true;
      });
      row.appendChild(btn);
    });

    select.addEventListener('change', function () { onModelChange(select, 'monitor'); });

    document.querySelectorAll('#keuzehulp [data-reset]').forEach(function (r) {
      r.addEventListener('click', function () {
        row.querySelectorAll('.ps-choice').forEach(function (x) { x.classList.remove('is-active'); });
        select.innerHTML = '<option value="">Kies eerst je merk</option>';
        select.disabled = true;
      });
    });
  }

  function forceStackedLayout(finder, children) {
    finder.style.display = 'block';
    children.forEach(function (child) {
      child.style.width = '100%';
      child.style.maxWidth = 'none';
      child.style.flex = 'none';
      child.style.boxSizing = 'border-box';
    });
  }

  function buildSecondaryWrapper(heading) {
    var wrapper = document.createElement('div');
    wrapper.className = 'ps-laptop-secondary';
    wrapper.style.width = '100%';
    wrapper.style.boxSizing = 'border-box';
    wrapper.style.marginTop = '26px';
    var label = document.createElement('p');
    label.className = 'ps-laptop-option__label';
    label.style.color = '#6f6860';
    label.style.fontWeight = '700';
    label.style.marginBottom = '12px';
    label.textContent = heading;
    wrapper.appendChild(label);
    return wrapper;
  }

  function buildSelectorBlock(guide, heading) {
    var selector = document.createElement('div');
    selector.className = 'ps-phone-selector';

    var visual = document.createElement('div');
    visual.className = 'ps-phone-visual';
    var oldVisual = guide.querySelector('.ps-windows-visual');
    if (oldVisual) {
      var img = oldVisual.querySelector('img');
      if (img) {
        img.className = 'ps-phone-image';
        visual.appendChild(img);
      }
      var badge = oldVisual.querySelector('.ps-windows-visual__badge');
      if (badge) {
        badge.className = 'ps-phone-visual__badge';
        visual.appendChild(badge);
      }
    }

    var controls = document.createElement('div');
    controls.className = 'ps-phone-controls';
    controls.innerHTML =
      '<p class="ps-step-label">Kies eerst je merk</p>' +
      '<h4>' + heading + '</h4>' +
      '<p>Selecteer je merk. Daarna tonen we alleen de beschikbare modellen van dat merk.</p>';

    selector.appendChild(visual);
    selector.appendChild(controls);
    guide.parentNode.insertBefore(selector, guide);
    guide.remove();
    return { selector: selector, controls: controls };
  }

  function arrangeBelow(selector, nodes) {
    var ref = selector;
    nodes.forEach(function (node) {
      if (node) {
        ref.after(node);
        ref = node;
      }
    });
  }

  function prepareAside(aside, plural) {
    if (!aside) return;
    var eyebrow = aside.querySelector('.ps-multi-order__eyebrow');
    if (eyebrow) eyebrow.textContent = 'Twijfel je of meerdere apparaten?';
    var h4 = aside.querySelector('h4');
    if (h4) h4.textContent = 'Ik twijfel over de maat, of ik wil verschillende afmetingen bestellen voor meerdere ' + plural;
    var textDiv = aside.querySelector('div');
    if (textDiv) {
      var p = document.createElement('p');
      p.style.marginTop = '10px';
      var a = document.createElement('a');
      a.className = 'ps-text-link';
      a.href = '/pages/privacyfilter-maat-bepalen#mm-meettool';
      a.textContent = 'Twijfel je over de maat van je scherm? Meet \'m hier in 2 minuten →';
      p.appendChild(a);
      textDiv.appendChild(p);
    }
  }

  function watchMatch(match) {
    if (!match || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (!match.hidden) {
        match.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }).observe(match, { attributes: true, attributeFilter: ['hidden'] });
  }

  function reorderLaptopPanel() {
    var group = document.querySelector('#ps-panel-laptop [data-laptop-results="maat"]');
    if (!group) return;
    var guide = group.querySelector('.ps-windows-guide');
    var finder = group.querySelector('.ps-laptop-finder');
    if (!guide || !finder) return;
    var optionBlocks = finder.querySelectorAll(':scope > .ps-laptop-option');
    if (optionBlocks.length < 3) return;
    var exactBlock = optionBlocks[0];
    var oldModelBlock = optionBlocks[2];
    var measureForm = finder.querySelector('[data-laptop-measure-form]');
    var dividers = finder.querySelectorAll(':scope > .ps-laptop-or');

    var built = buildSelectorBlock(guide, 'Welke laptop heb je?');
    buildLaptopBrandControls(built.controls);

    var exactLabel = exactBlock.querySelector('.ps-laptop-option__label');
    if (exactLabel) exactLabel.textContent = 'Ik weet mijn afmeting exact';
    var secondary = buildSecondaryWrapper('Weet je al welk formaat scherm je nodig hebt?');
    secondary.appendChild(exactBlock);
    addNoOfferNote(secondary);

    dividers.forEach(function (d) { d.remove(); });
    if (measureForm) measureForm.remove();
    oldModelBlock.remove();

    finder.appendChild(secondary);
    forceStackedLayout(finder, [secondary]);

    var feedback = group.querySelector('[data-laptop-feedback]');
    var match = group.querySelector('[data-laptop-match]');
    var help = group.querySelector('.ps-laptop-help');
    var aside = group.querySelector('.ps-multi-order');
    prepareAside(aside, 'laptops');
    arrangeBelow(built.selector, [feedback, match, finder, aside, help]);
    watchMatch(match);
  }

  function reorderMonitorPanel() {
    var panel = document.getElementById('ps-panel-monitor');
    if (!panel) return;
    var guide = panel.querySelector('.ps-monitor-guide');
    var finder = panel.querySelector('.ps-monitor-finder');
    if (!guide || !finder) return;
    var brandBlock = finder.querySelector('.ps-monitor-option--brand');
    var exactBlock = finder.querySelector(':scope > .ps-laptop-option');
    var measureForm = finder.querySelector('[data-monitor-measure-form]');
    var dividers = finder.querySelectorAll(':scope > .ps-laptop-or');
    if (!brandBlock || !exactBlock) return;

    var built = buildSelectorBlock(guide, 'Welke monitor heb je?');

    var oldLabel = brandBlock.querySelector(':scope > .ps-laptop-option__label');
    if (oldLabel) oldLabel.remove();
    while (brandBlock.firstChild) {
      built.controls.appendChild(brandBlock.firstChild);
    }
    brandBlock.remove();
    rebuildMonitorBrandControls(built.controls);
    var helpText = built.controls.querySelector('.ps-laptop-option__help');
    if (helpText && helpText.textContent.indexOf('hierboven') !== -1) {
      helpText.textContent = helpText.textContent.replace('hierboven', 'hieronder');
    }

    var secondary = buildSecondaryWrapper('Weet je al welk formaat scherm je nodig hebt?');
    secondary.appendChild(exactBlock);
    addNoOfferNote(secondary);

    dividers.forEach(function (d) { d.remove(); });
    if (measureForm) measureForm.remove();

    finder.appendChild(secondary);
    forceStackedLayout(finder, [secondary]);

    var feedback = panel.querySelector('[data-monitor-feedback]');
    var match = panel.querySelector('[data-monitor-match]');
    var help = panel.querySelector('.ps-laptop-help');
    var aside = panel.querySelector('.ps-multi-order');
    prepareAside(aside, 'monitoren');
    arrangeBelow(built.selector, [feedback, match, finder, aside, help]);
    watchMatch(match);
  }

  ready(function () {
    if (!document.getElementById('keuzehulp')) return;
    reorderLaptopPanel();
    reorderMonitorPanel();
  });
})();
